import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      width: _vm.withOrder ? "80%" : "1000"
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [!_vm.withOrder ? _c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.isSaving
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), !_vm.creditNoteId ? _c(VCardTitle, {
    staticClass: "headline"
  }, [_vm._v("Create a credit note")]) : _c(VCardTitle, {
    staticClass: "headline"
  }, [_vm._v("Edit the credit note")]), _c(VCardText, [_c("div", {
    attrs: {
      id: "data-container"
    }
  }, [_c("div", [_c("div", {
    staticClass: "d-flex align-center"
  }, [_c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.isTargetImporter,
      callback: function callback($$v) {
        _vm.isTargetImporter = $$v;
      },
      expression: "isTargetImporter"
    }
  }), !_vm.isTargetImporter ? _c("span", {
    staticClass: "text-bold"
  }, [_vm._v("Attached to a Customer")]) : _c("span", {
    staticClass: "text-bold"
  }, [_vm._v("Attached to an Importer")])], 1), !_vm.isTargetImporter ? _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.users,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "full_name",
      "item-value": "user_id",
      "return-object": "",
      label: "Customer",
      rules: [_vm.rules.mustSelectValue],
      "hide-details": "auto"
    },
    on: {
      change: _vm.changeUser
    },
    model: {
      value: _vm.userSelected,
      callback: function callback($$v) {
        _vm.userSelected = $$v;
      },
      expression: "userSelected"
    }
  }) : _vm.isTargetImporter ? _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      items: _vm.importers,
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id",
      "return-object": "",
      label: "Importer",
      rules: [_vm.rules.mustSelectValue],
      "hide-details": "auto"
    },
    on: {
      change: _vm.changeImporter
    },
    model: {
      value: _vm.importerSelected,
      callback: function callback($$v) {
        _vm.importerSelected = $$v;
      },
      expression: "importerSelected"
    }
  }) : _vm._e()], 1), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      maxlength: 100,
      label: "Extra description (additional info to show below the reference#)",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.extraDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "extraDescription", $$v);
      },
      expression: "creditNote.extraDescription"
    }
  }), _c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      maxlength: 200,
      label: "Main label used on the file (item & description)",
      required: "",
      rules: [_vm.rules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.itemDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "itemDescription", $$v);
      },
      expression: "creditNote.itemDescription"
    }
  }), _c(VCheckbox, {
    staticClass: "v-text-field-no-label",
    staticStyle: {
      width: "fit-content"
    },
    attrs: {
      label: "VAT applied on",
      "hide-details": "auto"
    },
    model: {
      value: _vm.isIncludeVat,
      callback: function callback($$v) {
        _vm.isIncludeVat = $$v;
      },
      expression: "isIncludeVat"
    }
  }), _vm.isIncludeVat ? _c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      label: "VAT (%)",
      placeholder: "0.0",
      type: "number",
      min: "0.1",
      required: "",
      rules: [_vm.rules.mustBeGreaterThan0],
      "hide-details": "auto"
    },
    model: {
      value: _vm.changeVat,
      callback: function callback($$v) {
        _vm.changeVat = $$v;
      },
      expression: "changeVat"
    }
  }) : _vm._e(), _c(VAutocomplete, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      items: _vm.getCurrencies,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "name",
      label: "Currency",
      required: "",
      rules: [_vm.rules.mustSelectValue],
      "hide-details": "auto"
    },
    model: {
      value: _vm.selectCurrency,
      callback: function callback($$v) {
        _vm.selectCurrency = $$v;
      },
      expression: "selectCurrency"
    }
  }), _c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      label: "Amount excl. VAT",
      placeholder: "0.00",
      type: "number",
      min: "0.01",
      required: "",
      rules: [_vm.rules.mustBeGreaterThan0],
      "hide-details": "auto"
    },
    on: {
      change: _vm.calculAmounts
    },
    model: {
      value: _vm.totalAmountExVatCurrency,
      callback: function callback($$v) {
        _vm.totalAmountExVatCurrency = $$v;
      },
      expression: "totalAmountExVatCurrency"
    }
  }), _vm.creditNote.initialCurrency !== "EUR" ? _c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      label: "Amount (€) excl. VAT",
      placeholder: "0.00",
      type: "number",
      min: "0.01",
      required: "",
      rules: [_vm.rules.mustBeGreaterThan0],
      "hide-details": "auto"
    },
    model: {
      value: _vm.totalAmountExVatEuro,
      callback: function callback($$v) {
        _vm.totalAmountExVatEuro = $$v;
      },
      expression: "totalAmountExVatEuro"
    }
  }) : _vm._e(), _vm.isIncludeVat ? _c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      label: "Amount incl. VAT",
      placeholder: "0.00",
      type: "number",
      min: "0.01",
      required: "",
      rules: [_vm.rules.mustBeGreaterThan0],
      "hide-details": "auto"
    },
    on: {
      blur: _vm.calculAmounts
    },
    model: {
      value: _vm.totalAmountCurrency,
      callback: function callback($$v) {
        _vm.totalAmountCurrency = $$v;
      },
      expression: "totalAmountCurrency"
    }
  }) : _vm._e(), _vm.creditNote.initialCurrency !== "EUR" && _vm.isIncludeVat ? _c(VTextField, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      label: "Amount (€) incl. VAT",
      placeholder: "0.00",
      type: "number",
      min: "0.01",
      required: "",
      rules: [_vm.rules.mustBeGreaterThan0],
      "hide-details": "auto"
    },
    on: {
      blur: _vm.calculAmounts
    },
    model: {
      value: _vm.totalAmountEuro,
      callback: function callback($$v) {
        _vm.totalAmountEuro = $$v;
      },
      expression: "totalAmountEuro"
    }
  }) : _vm._e(), _c(VTextarea, {
    staticClass: "v-text-field-no-label",
    attrs: {
      rows: "2",
      label: "Comment only for administrators",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "comment", $$v);
      },
      expression: "creditNote.comment"
    }
  })], 1)]), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.isWithoutOrderInvalidForm,
      loading: _vm.isSaving,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.saveCreditNote();
      }
    }
  }, [_vm._v(" Save as draft ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.isWithoutOrderInvalidForm,
      loading: _vm.isSaving,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.saveCreditNote(true);
      }
    }
  }, [_vm._v(" Save & validate ")])], 1)], 1) : _c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.isSaving
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), !_vm.creditNoteId ? _c(VCardTitle, {
    staticClass: "headline"
  }, [_vm.order.isInvoiced && !_vm.order.isImporterInvoiced ? [_vm._v(" Generate a credit note, issued by C&M FR ")] : !_vm.order.isInvoiced && _vm.order.isImporterInvoiced ? [_vm._v(" Generate a credit note, issued by " + _vm._s(_vm.order.importer.name) + " ")] : _vm._e(), _vm.order.isInvoiced && _vm.order.isImporterInvoiced ? [_vm._v(" Generate two credit notes, issued by C&M FR & " + _vm._s(_vm.order.importer.name) + " ")] : _vm._e()], 2) : _c(VCardTitle, {
    staticClass: "headline"
  }, [_vm._v(" Edit the credit note " + _vm._s(_vm.creditNote.numberLabel) + " ")]), _c("div", {
    staticClass: "pa-4 credit-note-maincontent"
  }, [_c("div", {
    staticClass: "credit-note-maincontent-summary"
  }, [_c("h3", [_vm._v("Order")]), _c("div", {
    staticClass: "search-products"
  }, [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.orderItemsAddables,
      "item-text": "display_name",
      "item-value": "orderItemId",
      "return-object": "",
      label: "Quick search product",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      change: _vm.selectOrderItems,
      "click:clear": function clickClear() {
        _vm.searchOrderItem = null;
        _vm.selectOrderItems(null);
      }
    },
    model: {
      value: _vm.searchOrderItem,
      callback: function callback($$v) {
        _vm.searchOrderItem = $$v;
      },
      expression: "searchOrderItem"
    }
  }, [[_c("div", {
    staticClass: "px-2"
  }, [_c("span", [_vm._v("Please enter the name of the product you wish to search for.")])])]], 2)], 1), _c("div", {
    staticClass: "summary-items"
  }, [_c("span", {
    staticClass: "text-h6"
  }, [_vm._v(" Order items "), _c("span", {
    staticClass: "nb-items"
  }, [_vm._v(" : " + _vm._s(_vm.getOrderNbItems) + " bottle" + _vm._s(_vm.getOrderNbItems > 1 ? "s" : "") + " ")])]), _c("div", {
    staticClass: "btn-all"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.addAll();
      }
    }
  }, [_c("span", [_vm._v("Add all")])])], 1)]), _c("div", {
    staticClass: "credit-note-maincontent-summary-items"
  }, [_vm._l(_vm.orderListItems, function (item) {
    return _c("div", {
      key: item.id_item,
      staticClass: "item-row"
    }, [_c("div", {
      staticClass: "item-row-informations",
      class: item.isSelected ? "disabled-group" : ""
    }, [_c("div", {
      staticClass: "item-row-winename"
    }, [_c("router-link", {
      staticClass: "router-link",
      attrs: {
        to: _vm.productDetails(item.wine)
      }
    }, [_c("WineNaming", {
      key: "wine-naming-left-".concat(item.wine.id_wine),
      attrs: {
        wineNamingData: item.wine.naming_data,
        isPrefixWinery: true,
        isSuffixBottling: true,
        isSuffixType: true
      }
    })], 1), _c("div", {
      staticClass: "item-row-casing"
    }, [_vm._v(" " + _vm._s(item.wine.sku) + " ")])], 1), _c("div", {
      staticClass: "item-row-lineprices"
    }, [_c("div", {
      staticClass: "item-row-quantity"
    }, [_c("div", [_c("div", {
      staticClass: "item-row-lineprices-title"
    }, [_vm._v("Qty (b)")]), _c("div", {
      staticClass: "item-row-lineprices-maindata"
    }, [_vm._v(" " + _vm._s(item.quantity) + " ")])])]), _c("div", {
      staticClass: "item-row-unitprice"
    }, [_c("div", [_c("div", {
      staticClass: "item-row-lineprices-title"
    }, [_vm._v("Price / b")]), _c("div", {
      staticClass: "item-row-lineprices-maindata text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.displayPrice(_vm.getUnitPriceCurrencyForItem(item, _vm.order.expedition_method), item.currency)) + " ")])])]), _c("div", {
      staticClass: "item-row-totalprice"
    }, [_c("div", {
      staticClass: "item-row-lineprices-title"
    }, [_vm._v("Total")]), _c("div", {
      staticClass: "item-row-lineprices-maindata text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.displayPrice(_vm.getUnitPriceCurrencyForItem(item, _vm.order.expedition_method), item.currency, item.quantity)) + " ")]), _c("div", {
      staticClass: "text-tax-info"
    }, [_vm._v(" " + _vm._s(" ") + "incl. sales tax" + _vm._s(!_vm.isConcernedByVat ? " . ex VAT" : "") + " ")])]), _c("div", {
      staticClass: "item-row-quantity"
    }, [_c("div", [_c("div", {
      staticClass: "item-row-lineprices-title"
    }, [_vm._v("Remaining (b)")]), _c("div", {
      staticClass: "item-row-lineprices-maindata"
    }, [_vm._v(" " + _vm._s(_vm.getRemainingQuantity(item.id_item, item.totalRemainingQuantity)) + " ")])])]), !item.isSelected ? _c("div", {
      staticClass: "item-row-quantity"
    }, [_c("div", [_c("div", {
      staticClass: "item-row-lineprices-maindata"
    }, [_c(VTextField, {
      staticClass: "ma-0 pa-0 text-center",
      attrs: {
        type: "number",
        value: 1,
        min: 0,
        max: item.totalRemainingQuantity
      },
      model: {
        value: item.creditNoteQuantity,
        callback: function callback($$v) {
          _vm.$set(item, "creditNoteQuantity", $$v);
        },
        expression: "item.creditNoteQuantity"
      }
    })], 1)])]) : _vm._e(), !item.isSelected ? _c("div", {
      staticClass: "item-row-add"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        title: "Add",
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.addItem(item, item.creditNoteQuantity);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        dark: "",
        small: ""
      }
    }, [_vm._v("mdi-plus")])], 1)], 1) : _vm._e()])])]);
  }), _vm.order.amount_shipping_currency > 0 ? _c("div", {
    staticClass: "item-row"
  }, [_c("div", {
    staticClass: "item-row-informations disabled-group"
  }, [_vm.order.amountShippingNotIncludedInItemsCurrency <= 0 ? [_c("div", {
    staticClass: "item-row-winename"
  }, [_vm._v("Shipping included")])] : [_c("div", {
    staticClass: "item-row-winename"
  }, [_vm._v("Shipping fee")]), _c("div", {
    staticClass: "item-row-lineprices"
  }, [_vm.orderIsPricePostedWithProperShipping ? [_c("div", {
    staticClass: "item-row-quantity"
  }, [_c("div", [_c("div", {
    staticClass: "item-row-lineprices-title"
  }, [_vm._v("Qty (b)")]), _c("div", {
    staticClass: "item-row-lineprices-maindata"
  }, [_vm._v(" " + _vm._s(_vm.getOrderNbRegularBottlesForShipping(_vm.order.items)) + " ")])])]), _c("div", {
    staticClass: "item-row-unitprice"
  }, [_c("div", [_c("div", {
    staticClass: "item-row-lineprices-title"
  }, [_vm._v("Unit Price")]), _c("div", {
    staticClass: "item-row-lineprices-maindata text-nowrap"
  }, [_vm._v(" " + _vm._s("".concat(_vm.displayPrice(_vm.getUnitPriceShippingCurrencyNotIncluded, _vm.order.currency))) + " ")])])]), _c("div", {
    staticClass: "item-row-totalprice"
  }, [_c("div", {
    staticClass: "item-row-lineprices-title"
  }, [_vm._v("Total")]), _c("div", {
    staticClass: "item-row-lineprices-maindata text-nowrap"
  }, [_vm._v(" " + _vm._s(_vm.displayPrice(_vm.order.amountShippingNotIncludedInItemsCurrency, _vm.order.currency)) + " ")]), _c("div", {
    staticClass: "text-tax-info"
  }, [_vm._v(" " + _vm._s(" ") + "incl. sales tax" + _vm._s(!_vm.isConcernedByVat ? " . ex VAT" : "") + " ")])]), _c("div", {
    staticClass: "item-row-quantity"
  }, [_c("div", [_c("div", {
    staticClass: "item-row-lineprices-title"
  }, [_vm._v("Remaining")]), _c("div", {
    staticClass: "item-row-lineprices-maindata"
  }, [_vm._v(" " + _vm._s(_vm.getOrderNbRegularBottlesForShipping(_vm.order.items) - _vm.getCreditNoteNbRegularBottlesForShipping(_vm.creditNote.items)) + " ")])])])] : [_c("div", {
    staticClass: "item-row-quantity"
  }, [_c("div", [_c("div", {
    staticClass: "item-row-lineprices-title"
  }, [_vm._v("Qty (b)")]), _c("div", {
    staticClass: "item-row-lineprices-maindata"
  }, [_vm._v(" " + _vm._s(_vm.getOrderNbItems) + " ")])])]), _c("div", {
    staticClass: "item-row-unitprice"
  }, [_c("div", [_c("div", {
    staticClass: "item-row-lineprices-title"
  }, [_vm._v("Price / b")]), _c("div", {
    staticClass: "item-row-lineprices-maindata text-nowrap"
  }, [_vm._v(" " + _vm._s("+ ".concat(_vm.displayPrice(_vm.order.amountShippingNotIncludedInItemsCurrency / _vm.getOrderNbItems, _vm.order.currency))) + " ")])])]), _c("div", {
    staticClass: "item-row-totalprice"
  }, [_c("div", {
    staticClass: "item-row-lineprices-title"
  }, [_vm._v("Total")]), _c("div", {
    staticClass: "item-row-lineprices-maindata text-nowrap"
  }, [_vm._v(" " + _vm._s(_vm.displayPrice(_vm.order.amountShippingNotIncludedInItemsCurrency, _vm.order.currency)) + " ")]), _c("div", {
    staticClass: "text-tax-info"
  }, [_vm._v(" " + _vm._s(" ") + "incl. sales tax" + _vm._s(!_vm.isConcernedByVat ? " . ex VAT" : "") + " ")])]), _c("div", {
    staticClass: "item-row-quantity"
  }, [_c("div", [_c("div", {
    staticClass: "item-row-lineprices-title"
  }, [_vm._v("Remaining (b)")]), _c("div", {
    staticClass: "item-row-lineprices-maindata"
  }, [_vm._v(" " + _vm._s(_vm.getOrderRemainingQuantity()) + " ")])])])]], 2)]], 2)]) : _vm._e()], 2)]), _c("div", {
    staticClass: "credit-note-maincontent-data"
  }, [_c("h3", [_vm._v("Credit Note")]), [_c("div", {
    staticClass: "amount"
  }, [_c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "0.00",
      label: "Amount",
      "hide-details": "auto",
      disabled: true
    },
    model: {
      value: _vm.getTotalAmount,
      callback: function callback($$v) {
        _vm.getTotalAmount = $$v;
      },
      expression: "getTotalAmount"
    }
  }), _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      placeholder: "0.00",
      label: "Remaining amount",
      "hide-details": "auto",
      disabled: true
    },
    model: {
      value: _vm.getRemainingAmount,
      callback: function callback($$v) {
        _vm.getRemainingAmount = $$v;
      },
      expression: "getRemainingAmount"
    }
  })], 1)], _c("div", [_c("div", {
    staticClass: "summary-items"
  }, [_c("span", {
    staticClass: "text-h6"
  }, [_vm._v(" Credit note items "), _c("span", {
    staticClass: "nb-items"
  }, [_vm._v(" : " + _vm._s(_vm.getCreditNoteNbItems) + " bottle" + _vm._s(_vm.getCreditNoteNbItems > 1 ? "s" : "") + " ")])]), _c("div", {
    staticClass: "btn-all"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: true,
      disabled: _vm.disableRemoveAll
    },
    on: {
      click: function click($event) {
        return _vm.deleteAll();
      }
    }
  }, [_c("span", [_vm._v("Remove all")])])], 1)]), _c("div", {
    staticClass: "credit-note-maincontent-summary-items"
  }, _vm._l(_vm.creditNoteListItems, function (item) {
    return _c("div", {
      key: item.id,
      staticClass: "item-row"
    }, [_c("div", {
      staticClass: "item-row-informations"
    }, [_c("div", {
      staticClass: "item-row-winename"
    }, [_c("router-link", {
      staticClass: "router-link",
      attrs: {
        to: _vm.productDetails(item.wine)
      }
    }, [_c("WineNaming", {
      key: "wine-naming-".concat(item.wine.id_wine),
      attrs: {
        wineNamingData: item.wine.naming_data,
        isPrefixWinery: true,
        isSuffixBottling: true,
        isSuffixType: true
      }
    })], 1), _c("div", {
      staticClass: "item-row-casing"
    }, [_vm._v(" " + _vm._s(item.wine.sku) + " ")])], 1), _c("div", {
      staticClass: "item-row-lineprices"
    }, [_c("div", {
      staticClass: "item-row-quantity"
    }, [_c("div", [_c("div", {
      staticClass: "item-row-lineprices-title"
    }, [_vm._v("Qty (b)")]), _c("div", {
      staticClass: "item-row-lineprices-maindata"
    }, [_c(VTextField, {
      key: _vm.quantityToggleKey,
      staticClass: "ma-0 pa-0 text-center",
      attrs: {
        type: "number",
        value: item.quantity,
        min: 1,
        max: item.orderQuantity
      },
      on: {
        input: function input($event) {
          _vm.isItemShippingUpdated = false;
        },
        change: function change($event) {
          return _vm.changeQuantityCreditNote(item, $event);
        }
      },
      model: {
        value: item.quantity,
        callback: function callback($$v) {
          _vm.$set(item, "quantity", $$v);
        },
        expression: "item.quantity"
      }
    })], 1)])]), _c("div", {
      staticClass: "item-row-unitprice"
    }, [_c("div", [_c("div", {
      staticClass: "item-row-lineprices-title"
    }, [_vm._v("Price / b")]), _c("div", {
      staticClass: "item-row-lineprices-maindata text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.displayPrice(item.unitPriceCurrency + item.unitDefaultShippingCurrencyIncluded, item.currency)) + " ")])])]), _c("div", {
      staticClass: "item-row-totalprice"
    }, [_c("div", {
      staticClass: "item-row-lineprices-title"
    }, [_vm._v("Total")]), _c("div", {
      staticClass: "item-row-lineprices-maindata text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.displayPrice(item.unitPriceCurrency + item.unitDefaultShippingCurrencyIncluded, item.currency, item.quantity)) + " ")]), _c("div", {
      staticClass: "text-tax-info"
    }, [_vm._v(" " + _vm._s(" ") + "incl. sales tax" + _vm._s(!_vm.isConcernedByVat ? " . ex VAT" : "") + " ")])]), _vm.order.is_destination_inbound && _vm.order.status === _vm.orderStatus.find(function (x) {
      return x.id === "INBOUND";
    }).status ? _c("div", {
      staticClass: "item-row-totalprice"
    }, [_c("div", [_c("div", {
      staticClass: "item-row-lineprices-title"
    }, [_vm._v("Inbound stock")]), _c("div", {
      staticClass: "item-row-lineprices-maindata"
    }, [_c(VCheckbox, {
      staticClass: "v-text-field-no-label",
      attrs: {
        "hide-details": "auto",
        label: "Deplete"
      },
      model: {
        value: item.depleteInboundStock,
        callback: function callback($$v) {
          _vm.$set(item, "depleteInboundStock", $$v);
        },
        expression: "item.depleteInboundStock"
      }
    })], 1)])]) : _vm._e(), _c("div", {
      staticClass: "item-row-remove"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        title: "Remove",
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.deleteItem(item);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        dark: "",
        small: ""
      }
    }, [_vm._v("mdi-delete")])], 1)], 1)])])]);
  }), 0)]), _c("div", {
    staticClass: "amount"
  }, [!_vm.isItemShippingUpdated ? _c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      value: "Recalculating...",
      label: "Shipping price",
      "hide-details": "auto",
      readonly: ""
    }
  }) : [_c(VTextField, {
    staticClass: "v-text-field-no-label",
    attrs: {
      value: _vm.itemShippingAmountCurrencyMinusShippingIncluded,
      label: "Shipping price",
      placeholder: "0.00",
      type: "number",
      min: "0.0",
      required: "",
      "hide-details": "auto",
      readonly: ""
    }
  }), _vm.orderIsPricePostedWithProperShipping && _vm.order.amountShippingNotIncludedInItemsCurrency > 0 ? _c("div", {
    staticClass: "text-smaller-2"
  }, [_vm._v(" " + _vm._s("(".concat(_vm.getCreditNoteNbRegularBottlesForShipping(_vm.creditNote.items), " x ").concat(_vm.displayPrice(_vm.getUnitPriceShippingCurrencyNotIncluded, _vm.itemShipping.currency), ")")) + " ")]) : _vm._e()]], 2), _c("div", [_c(VTextarea, {
    staticClass: "v-text-field-no-label",
    attrs: {
      rows: "2",
      label: "Comment",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "comment", $$v);
      },
      expression: "creditNote.comment"
    }
  })], 1), _c("div", [_c("div", {
    staticClass: "d-flex items-start"
  }, [_c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.isAppliedInFullOnSourceOrder,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "isAppliedInFullOnSourceOrder", $$v);
      },
      expression: "creditNote.isAppliedInFullOnSourceOrder"
    }
  }), !_vm.creditNote.isAppliedInFullOnSourceOrder ? _c("span", {
    staticClass: "text-bold"
  }, [_vm._v(" Create a credit note for a future application ")]) : _c("span", {
    staticClass: "text-bold"
  }, [_vm._v(" Automatically apply the full amount on the original order ")])], 1)]), !_vm.creditNote.createOrder && !_vm.order.isStockTransfer ? _c("div", [_c("div", {
    staticClass: "d-flex items-start"
  }, [_c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.isReturnedToInventory,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "isReturnedToInventory", $$v);
      },
      expression: "creditNote.isReturnedToInventory"
    }
  }), !_vm.creditNote.isReturnedToInventory ? _c("span", {
    staticClass: "text-bold"
  }, [_vm._v(" Financial-only credit, do not affect inventory ")]) : _c("div", [_c("div", {
    staticClass: "text-bold"
  }, [_vm._v("Pick-up and return the products to inventory")]), _c("div", {
    staticClass: "text-smaller"
  }, [_vm._v(" Save as draft to be able to verify the good return of the products, and generate "), _vm.creditNoteId ? [_vm._v("the updated")] : _vm._e(), _vm._v(" packing list ")], 2), _c("div", [_vm.creditNoteId ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      loading: _vm.exportingPdf.isPending,
      rounded: ""
    },
    on: {
      click: _vm.getPackingList
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-file mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Packing list ")], 1) : _vm._e()], 1)])], 1)]) : _vm._e(), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      disabled: _vm.isSaving,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v(" Cancel ")]), !_vm.creditNote.createOrder ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.isInvalidForm,
      loading: _vm.isSaving,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.saveCreditNote();
      }
    }
  }, [_vm._v(" Save as draft ")]) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.isInvalidForm,
      loading: _vm.isSaving,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.saveCreditNote(true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.creditNote.createOrder ? "Save & split order" : "Save & validate") + " ")])], 1)], 2)])], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };